import { render, staticRenderFns } from "./GlobalDispatchFooter.vue?vue&type=template&id=c78c6f1c&scoped=true&name=global-dispatch-footer&"
import script from "./GlobalDispatchFooter.vue?vue&type=script&lang=js&"
export * from "./GlobalDispatchFooter.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDispatchFooter.vue?vue&type=style&index=0&id=c78c6f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78c6f1c",
  null
  
)

export default component.exports